import React, { useEffect, useState } from 'react';
import Testimonials from '../Testimonials';
import logo from '../bee-logo.png';
import { Link } from 'react-router-dom';

const galleryImages = [
  { src: '/photos/Photo1.jpeg', alt: 'Lawn and landscaping service photo 1' },
  { src: '/photos/middle.jpeg', alt: 'Lawn mower service photo' },
  { src: '/photos/Photo2.jpeg', alt: 'Lawn and landscaping service photo 2' },
];

function MainPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const to = 'buzz34205@gmail.com';
    const subject = `New Quote Request from ${formData.name || 'Website Visitor'}`;

    const bodyLines = [
      `Name: ${formData.name || 'n/a'}`,
      `Email: ${formData.email || 'n/a'}`,
      '',
      'Message:',
      `${formData.message || 'n/a'}`,
    ];

    const body = encodeURIComponent(bodyLines.join('\n'));
    const mailtoUrl = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${body}`;

    window.location.href = mailtoUrl;

    setStatus('success');
    setFormData({ name: '', email: '', message: '' });
    setTimeout(() => setStatus('idle'), 5000);
  };

  const goToPreviousSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
  };

  return (
    <div className="App">
      <header className="navbar">
        <div className="logo-title">
          <img src={logo} alt="Bee Logo" className="logo" />
          <div>
            <h1 className="site-title">The Neighborhood Buzz</h1>
            <p className="tagline">Lawn Care You Can Count On</p>
          </div>
        </div>
        <nav>
          <ul className="nav-links">
            <li><a href="#top">Home</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>

      <main>
        <section className="quote">
          <blockquote>
            “I show up. I text back. I take care of your lawn like it’s mine.”
          </blockquote>
          <cite>— Brandon Saathoff, Owner</cite>
        </section>

        <section className="services">
          <h2>Services Offered</h2>
          <div className="service-cards">
            <button>Lawn Care</button>
            <button>Landscape Cleanups</button>
            <button>Hedge Trimming</button>
            <button>Pruning</button>
            <button>Weed Control</button>
            <button>Landscaping Enhancement</button>
          </div>
        </section>

        <section className="area">
          <p><strong>Serving West Bradenton, Palma Sola, South Bradenton & Bayshore Gardens</strong></p>
          <button
            className="quote-button"
            onClick={() => {
              const formSection = document.getElementById('contact');
              if (formSection) {
                formSection.scrollIntoView({ behavior: 'smooth' });
                formSection.classList.add('highlight');
                setTimeout(() => {
                  formSection.classList.remove('highlight');
                }, 1500);
              }
            }}
          >
            Request a Quote
          </button>
        </section>

        <section className="photo-gallery">
          <h2>Our Work</h2>
          <div className="gallery-carousel">
            <div className="gallery-slide middle">
              <img
                src={galleryImages[currentSlide].src}
                alt={galleryImages[currentSlide].alt}
              />
            </div>

            <div className="gallery-controls">
              <button
                type="button"
                className="gallery-button"
                onClick={goToPreviousSlide}
                aria-label="Previous photo"
              >
                ← Previous
              </button>
              <button
                type="button"
                className="gallery-button"
                onClick={goToNextSlide}
                aria-label="Next photo"
              >
                Next →
              </button>
            </div>
          </div>
        </section>

        <Link to="/chat" className="rooty-main-link">
          <img src="/assets/icons/AI/rooty.png" alt="Rooty" className="rooty-main-icon" />
          Chat with Rooty
        </Link>

        <section className="why-choose">
          <h2>Why Choose The Neighborhood Buzz?</h2>
          <div className="credentials-container">
            <div className="credential-card">
              <img src="/assets/icons/credentials/icon-bbb.png" alt="BBB Icon" />
              <div>
                <strong>A+ BBB Rating</strong>
                <p>Trusted and accredited by the Better Business Bureau</p>
              </div>
            </div>

            <div className="credential-card">
              <img src="/assets/icons/credentials/icon-bmp.png" alt="BMP Icon" />
              <div>
                <strong>BMP Certified</strong>
                <p>Better Management Practices in lawn care</p>
              </div>
            </div>

            <div className="credential-card">
              <img src="/assets/icons/credentials/icon-exerience.png" alt="Experience Icon" />
              <div>
                <strong>15 Years Experience</strong>
                <p>Serving the Bradenton community with pride</p>
              </div>
            </div>

            <div className="credential-card">
              <img src="/assets/icons/credentials/icon-insured.png" alt="Licensed and Insured Icon" />
              <div>
                <strong>Licensed &amp; Insured</strong>
                <p>Your property is protected with professional coverage</p>
              </div>
            </div>
          </div>
        </section>

        <section className="google-reviews">
          <h2>What Our Customers Are Saying</h2>
          <div
            className="elfsight-app-69b25277-d0ee-47c0-897b-c510ba1af1d7"
            data-elfsight-app-lazy
          ></div>
        </section>

        <section id="testimonials">
          <Testimonials />
        </section>
      </main>

      <footer id="contact">
        <h2>Request a Quote</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          />
          <button type="submit">Submit</button>
        </form>

        {status === 'success' && (
          <p className="success-msg">
            Your email app should have opened—hit send to finish your quote request.
          </p>
        )}
      </footer>
    </div>
  );
}

export default MainPage;

